/**
 * 通用js方法封装处理
 *
 * @format
 */

// 回显数据字典
export function selectDictLabel(datas: any, value) {
	if (value === undefined) {
		return '';
	}
	const actions: any = [];
	Object.keys(datas).some((key) => {
		if (datas[key].value == `${value}`) {
			actions.push(datas[key].label);
			return true;
		}
	});
	if (actions.length === 0) {
		actions.push(value);
	}
	return actions.join('');
}

// 回显数据字典（字符串数组）
export function selectDictLabels(datas: any, value, separator) {
	if (value === undefined) {
		return '';
	}
	const actions: any = [];
	const currentSeparator = undefined === separator ? ',' : separator;
	const temp = value.split(currentSeparator);
	Object.keys(value.split(currentSeparator)).some((val) => {
		let match = false;
		Object.keys(datas).some((key) => {
			if (datas[key].value == `${temp[val]}`) {
				actions.push(datas[key].label + currentSeparator);
				match = true;
			}
		});
		if (!match) {
			actions.push(temp[val] + currentSeparator);
		}
	});
	return actions.join('').substring(0, actions.join('').length - 1);
}

// 返回项目路径
export function getNormalPath(p) {
	if (p.length === 0 || !p || p == 'undefined') {
		return p;
	}
	const res = p.replace('//', '/');
	if (res[res.length - 1] === '/') {
		return res.slice(0, res.length - 1);
	}
	return res;
}
